"use client";

import { Minus, Plus } from "lucide-react";

type QuantityStepperProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
};

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max
}: QuantityStepperProps) {
  return (
    <div className="grid h-11 w-36 grid-cols-3 overflow-hidden rounded-md border border-neutral-100 bg-white">
      <button
        type="button"
        aria-label="Kurangi qty"
        onClick={() => onChange(Math.max(min, value - 1))}
        className="flex items-center justify-center text-ink disabled:text-zinc-300"
        disabled={value <= min}
      >
        <Minus size={16} />
      </button>
      <div className="flex items-center justify-center text-sm font-bold text-ink">
        {value}
      </div>
      <button
        type="button"
        aria-label="Tambah qty"
        onClick={() =>
          onChange(max !== undefined ? Math.min(max, value + 1) : value + 1)
        }
        className="flex items-center justify-center text-ink disabled:text-zinc-300"
        disabled={max !== undefined && value >= max}
      >
        <Plus size={16} />
      </button>
    </div>
  );
}
